export const account_home_password = {
  edit_password: "Password",
  edit_password_blurb:
    "Change your password through our secure identity provider. You'll need your current password to confirm the change.",
  edit_password_cta: "Change Password",
  edit_password_value_mask: "••••••••",
} as const;
